// extracted by css-extract-rspack-plugin
var _1 = "_5IKn7CaYKe51g06dJGKD3A--";
var _2 = "oEv7K4yGuBddFB0ZXFTrrg-- _5IKn7CaYKe51g06dJGKD3A--";
var _3 = "_4n7O-nVFQCD-LZohGSu-tg-- _5IKn7CaYKe51g06dJGKD3A--";
var _4 = "SKei8HehQCeeMK-8rmV5PA-- _5IKn7CaYKe51g06dJGKD3A--";
export { _1 as "content", _2 as "noBorder", _3 as "noMargin", _4 as "noPadding" }
